import { render, staticRenderFns } from "./procedure_patients.vue?vue&type=template&id=311e9156&"
import script from "./procedure_patients.vue?vue&type=script&lang=js&"
export * from "./procedure_patients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports